module.exports = __webpack_public_path__ + "static/img/14.7dd090d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mOfficial/14.png
// module id = pSsB
// module chunks = 1